module.exports = __webpack_public_path__ + "img/pagseguro.48e7a3b1.png";